class DiscountSummary {
    retailPricePerBrick;
    discountedPricePerBrick;
    crowdfundingDiscount;
    volumeDiscount;
    constructor(data) {
        this.retailPricePerBrick = data.retailPricePerBrick;
        this.discountedPricePerBrick = data.discountedPricePerBrick;
        this.crowdfundingDiscount = data.crowdfundingDiscount;
        this.volumeDiscount = data.volumeDiscount;
    }
}
export default DiscountSummary;
